export default __webpack_public_path__ + "static/media/servify-logo-96x96.c5498ee1.png";